<template>
  <div class="panel-content agenda" :class="{ 'agenda-back': isInfo }">
    <div v-for="agenda in scheduleList" :key="agenda.theme" class="agenda-item">
      <div class="agenda-time">
        {{ agenda.startTimeDate }} -
        {{ agenda.endTimeDate }}
      </div>
      <div class="agenda">
        <div class="agenda-content">
          {{ agenda.theme }}
        </div>
        <div v-for="(guest, i) in agenda.agendaGuest" :key="i">
          <div class="agenda-guest">
            {{ guest.name }}
          </div>
          <div class="agenda-content-desc">
            {{ guest.enterprise }} {{ guest.duty }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { $subscriber, cr } from "fire-wind-water";
import * as moment from "moment";
export default {
  name: "Agenda",
  data() {
    return {
      isInfo: this.$route.path.indexOf("Info") > 0,
      webinarInfo: {},
      scheduleList: []
    };
  },
  methods: {
    init() {
      $subscriber.subscribe("webinarInfo", data => {
        //把嘉宾的数据 和日常的数据组合一下
        cr.each(data.agendaList, d => {
          d.endTimeDate = moment(d.endTime * 1000).format("HH:mm");
          d.startTimeDate = moment(d.startTime * 1000).format("HH:mm");
          cr.each(d.agendaGuest, n => {
            cr.each(data.guestList, list => {
              if (list.webinarGuestId == n.webinarGuestId) {
                n.duty = list.duty; //"这是职务"
                n.enterprise = list.enterprise; //"这是公司"
                n.department = list.department; //"这是部门"
              }
            });
          });
        });
        this.scheduleList = data.agendaList;
      });
    }
  },
  created() {
    this.init();
  }
};
</script>
